/**
 *  fully expect that we will remove this in the future, but localisation needs to come from one place in the current incarnation
 *  */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { SliceStatus } from '../../interfaces/Redux';

import { get } from '../../services/http'

import { defaultLocalisation } from '../../services/localisationDefaults';
import routeListen from '../../services/routeListen';

interface LanguageDictionary {
    [key: string]: any
}

export interface LocalisationState {
  languageDictionary: LanguageDictionary
  language: string
  status: SliceStatus
  error?: string
}

const initialState: LocalisationState = {
  languageDictionary: {...defaultLocalisation},
  language: 'en',
  status: SliceStatus.idle,
  error: '',

}

export const localisationSlice = createSlice({
  name: 'localisation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLocalisation.pending, (state) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchLocalisation.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded;
          // Add any fetched posts to the array
          state.languageDictionary = {...defaultLocalisation, ...action.payload.languageDictionary};
          state.language = action.payload.language
          state.error = undefined;
        }
        
      })
      .addCase(fetchLocalisation.rejected, (state, action) => {
        state.status = SliceStatus.failed
        state.error = action.error.message
      })
  }
})

export const fetchLocalisation = createAsyncThunk('localisation/fetchLocalisation', async () => {
    const { data } = await  get(`api/localisation/language?IetfLanguageTag=${window.navigator.language}&packageName=${routeListen.shortName()}`)
        .catch((response) => {
          throw new Error(response.message);
        });
      
    return {
        language: window.navigator.language,
        languageDictionary: data.LanguageDictionary
    }
});


export default localisationSlice.reducer
